<p-dialog
  [visible]="dialog.visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '34rem', maxWidth: '92vw' }"
  styleClass="branduals-dialog license-warn-dialog"
  [header]="'download.licenseWarn.title' | translate">

  @if (dialog.evidence(); as evidence) {
    <p class="dialog-subtitle">
      @if (isExpired()) {
        {{ 'download.licenseWarn.expiredBody' | translate: {
          count: evidence.count,
          date: (evidence.soonestExpiresAt | displayDate:'medium') ?? ''
        } }}
      } @else {
        {{ 'download.licenseWarn.notYetValidBody' | translate: {
          count: evidence.count,
          startDate: (evidence.earliestStartsAt | displayDate:'medium') ?? ''
        } }}
      }
    </p>

    @if (names().length > 0) {
      <div class="warn-samples">
        <span class="section-label">{{ 'download.licenseWarn.sampleNames' | translate }}</span>
        <ul class="warn-sample-list">
          @for (name of names(); track name) {
            <li>{{ name }}</li>
          }
        </ul>
      </div>
    }
  }

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text"
      [label]="'download.licenseWarn.cancel' | translate"
      (click)="dialog.decide(false)"></button>
    <button pButton type="button" class="p-button-outlined"
      [label]="'download.licenseWarn.confirm' | translate"
      (click)="dialog.decide(true)"></button>
  </ng-template>
</p-dialog>
